import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { myLocalStorage } from "../../../components/StorageHelper";
import moment from "moment";
import { NGROK } from "../../../APIs";
import UserRoleAnalysis from "./Components/UserRoleAnalysis";
import axios from "axios";
import useUserStore from "../../../services/userStore";
import { AiOutlineBarChart } from "react-icons/ai";
import { FaServer } from "react-icons/fa";
import TailwinButton from "../../../tailwind-ui/components/TailwinButton";
import { Stack, Tooltip } from "@mui/material";
import { triggerCloudSync } from "../../../triggerCloudSync";
import useCloudSyncStore from "../../../services/useCloudSyncStore";
import useNotificationStore from "../../../services/notificationStore";
import TailwindFilterHeader from "../../../tailwind-ui/components/TailwindFilterHeader";
import TailwindCollapsibleTable from "../../../tailwind-ui/components/TailwindCollapsibleTable";
import TimelineIcon from "@mui/icons-material/Timeline";
import { User2Icon } from "lucide-react";
import CloudEntityAnalytics from "../../../components/v2components/CloudAnalytics/CloudEntityAnalytics";

const GcpUserInfo = () => {
  const location = useLocation();
  const { user: initialUser } = location.state || { user: {} };
  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;
  const [selectedTab, setSelectedTab] = useState("analytics");
  const [user, setUser] = useState(initialUser);
  const [groups, setGroups] = useState(initialUser?.groups || []);
  const [roleDefinitions, setRoleDefinitions] = useState(
    initialUser?.roles || [],
  );
  const [isSyncing, setIsSyncing] = useState(false);
  const { role } = useUserStore((state) => state.user);
  const syncStatus = useCloudSyncStore((state) => state.syncStatus);
  let { gcpConfig } = useNotificationStore.getState();
  let { userName, projectId, syncedAt, email } = user;
  const [projectIdList, setProjectIdList] = useState([]);
  const latestprojectId = myLocalStorage.getItem("gcpSelectedProjectId");
  const [project, setProjectId] = useState("");

  const handleSync = async () => {
    try {
      const data = await triggerCloudSync(
        "gcp",
        "/api/gcp-sync/manual",
        latestTenant,
      );
      console.log("GCP Sync complete:", data);
    } catch (error) {
      console.error("GCP Sync failed", error);
    }
  };

  const getDisplayItems = (items) => items.slice(0, 2);
  const getMoreCount = (items) => items.length - 2;
  const getRemainingItems = (roles) =>
    roles.slice(getDisplayItems(roles).length);

  const handleProject = (value) => {
    const project = projectIdList.find((project) => project === value);
    if (project !== undefined) {
      myLocalStorage.setItem("gcpSelectedProjectId", project);
      setProjectId(project);
    }
  };

  const fetchUserProjectList = async () => {
    try {
      const response = await axios.get(
        `${NGROK}/api/gcp/get-config-user-projects?tenantName=${latestTenant}&gcpAccountEmail=${email}`,
      );

      const projects = response?.data || [];
      setProjectIdList(projects);

      if (projects.length > 0) {
        let latest = null;

        try {
          latest =
            typeof latestprojectId === "string"
              ? JSON.parse(latestprojectId)
              : latestprojectId;
        } catch (e) {
          latest = null;
        }

        const match = latest ? projects.find((item) => item === latest) : null;

        const selected = match || projects[0];
        myLocalStorage.setItem("gcpSelectedProjectId", selected);

        setProjectId(selected);
      } else {
      }
    } catch (error) {
      console.error("Failed to fetch project for user:", error);
    }
  };
  useEffect(() => {
    if (role === "TENANT_USER") {
      fetchUserProjectList();
    }
    if (role !== "TENANT_USER") setSelectedTab("analytics");
    else setSelectedTab("resources");
  }, [role]);
  useEffect(() => {
    if (role === "TENANT_USER") {
      setProjectId(latestprojectId);
    }
  }, [latestprojectId, project]);


  return <CloudEntityAnalytics cloudProvider={"gcp"} email={email} entityId={email} entityType="user" projectId={projectId} roles={roleDefinitions} syncedAt={syncedAt} entityName={projectId} />
};

export default GcpUserInfo;
